module.exports = __webpack_public_path__ + "img/unionIntroduceBanner.0067b498.jpg";